module.exports = {"320681100":"汇龙镇","320681102":"惠萍镇","320681104":"东海镇","320681106":"南阳镇","320681107":"海复镇","320681108":"合作镇","320681109":"王鲍镇","320681110":"吕四港镇","320681400":"启东经济开发区","320681401":"启东滨海工业园","320681402":"启东滨江化工园","320681403":"江苏吕四海洋经济开发区","320681404":"启隆生态科技产业园","320681405":"启东海工船舶工业园","320681406":"启东江海产业园","320681407":"圆陀角旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320681.json
// module id = 814
// module chunks = 0